module.exports = __webpack_public_path__ + "img/B3.6228729a.jpg";